import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-customer-form',
  templateUrl: './edit-customer-form.component.html',
  styleUrls: ['./edit-customer-form.component.css']
})
export class EditCustomerFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
